"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _plugin = require("@leverege/plugin");
var _EmptyDelegate = _interopRequireDefault(require("./EmptyDelegate"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const I18NextDelegateFactory = _plugin.Plugins.createFactory('I18NDelegateCreator', {
  pluginKey: 'delegateCreator',
  defaultObject: _EmptyDelegate.default
});
var _default = I18NextDelegateFactory;
exports.default = _default;